module.exports = __webpack_public_path__ + "static/media/numero_celular.58615425.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallWindow/numero_celular.svg
// module id = 1759
// module chunks = 0